import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import Container from "@mui/material/Container";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";
import { useNavigate } from "react-router-dom";
import { CircularProgress, Typography } from "@mui/material";
import jwt_decode from "jwt-decode";

// function createData(name, calories, fat, carbs, protein) {
//   return { name, calories, fat, carbs, protein };
// }

// const rows = [
//   createData("45f455665", 159, 6.0, 24, 4.0),
//   createData("544565565", 237, 9.0, 37, 4.3),
// ];

export default function OrdersNaem({ t, i18n }) {
  let navigate = useNavigate();

  const [orders, setOrders] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    fetch(
      `https://fatora-sa.herokuapp.com/api/v1/invoices/get-casheir-invoices-for-user/62160bc81c5ceec125780794/${
        jwt_decode(localStorage.getItem("Token")).user._id
      }`
    )
      .then((res) => res.json())
      .then((data) => setOrders(data.reverse()))
      .then(() => setLoading(false))
      .catch((e) => console.log("error: ", e.message));
  }, []);

  return (
    <Container
      style={{ paddingTop: 100, height: 1000, backgroundColor: "#F6F6F6" }}
    >
      <TableContainer component={Paper} style={{ backgroundColor: "#fff" }}>
        <Table sx={{}} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell
                align={i18n.language === "ar" ? "left" : "right"}
                style={{ fontSize: 20, fontWeight: "bold" }}
              >
                الطلبات {loading && <CircularProgress size={20} />}
              </TableCell>
              <TableCell align="left"></TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="right"></TableCell>

              {/* <TableCell align="right">Fat&nbsp;(g)</TableCell>
            <TableCell align="right">Carbs&nbsp;(g)</TableCell>
            <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {orders?.map((row) => (
              <TableRow
                onClick={() =>
                  navigate(`/order/${row.itemNo}`, {
                    state: {
                      invoice: row,
                      //...values
                    },
                  })
                }
                key={row._id}
              >
                <TableCell
                  align={i18n.language === "ar" ? "left" : "right"}
                  component="th"
                  scope="row"
                >
                  {row.itemNo}
                </TableCell>
                <TableCell
                  align={i18n.language === "ar" ? "left" : "right"}
                  component="th"
                  scope="row"
                >
                  <Chip
                    size="small"
                    label={row.isShipped ? "تم التوصيل" : "تجهيز الطلب"}
                    color="success"
                  />
                </TableCell>
                <TableCell
                  align={i18n.language === "ar" ? "right" : "left"}
                  component="th"
                  scope="row"
                >
                  <Chip
                    size="small"
                    label={new Date(row.created_at).toLocaleDateString()}
                    color="info"
                  />
                </TableCell>
                <TableCell align={i18n.language === "ar" ? "right" : "left"}>
                  {row.price.toFixed(2)}
                </TableCell>
                {/* <TableCell align="right">{row.fat}</TableCell>
              <TableCell align="right">{row.carbs}</TableCell>
              <TableCell align="right">{row.protein}</TableCell> */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
}
